import { Box, IconButton, Tooltip } from '@mui/material';
import BrushIcon from '@mui/icons-material/Brush';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useState } from 'react';
import MessageModal from '../message-modal/MessageModal';
import { useTranslation } from 'react-i18next';

interface EditButtonsRowProps {
  /** Base id used for click tracking (Google Analytics). */
  id?: string;
  onEdit: () => void;
  onDelete: () => void;
}

export const EditButtonsRow = ({ id, onEdit, onDelete }: EditButtonsRowProps) => {
  const { t } = useTranslation();
  const [deleteMessageModalOpen, setDeleteMessageModalOpen] = useState(false);
  return (
    <Box sx={{ display: 'flex' }}>
      {deleteMessageModalOpen && (
        <MessageModal
          open={deleteMessageModalOpen}
          modalTitle={t('messages.deleteContact')}
          modalMessage={t('messages.deleteBusinessContactDialog')}
          actionButtonText={t('buttons.goBack')}
          actionButtonFn={() => setDeleteMessageModalOpen(false)}
          goBackButtonText={t('buttons.delete')}
          onDismiss={() => setDeleteMessageModalOpen(false)}
          onClose={() => {
            onDelete();
          }}
        />
      )}
      <Tooltip title={t('buttons.edit')} arrow placement='top'>
        <IconButton
          id={`${id ?? 'supplierContactCardEditButtonsRow'}EditIconBtn`}
          onClick={() => {
            onEdit();
          }}
        >
          <BrushIcon id={`${id ?? 'supplierContactCardEditButtonsRow'}EditIconBtnBrushIcon`} />
        </IconButton>
      </Tooltip>
      <Tooltip title={t('buttons.delete')} arrow placement='top'>
        <IconButton
          id={`${id ?? 'supplierContactCardEditButtonsRow'}DeleteIconBtn`}
          onClick={() => {
            setDeleteMessageModalOpen(true);
          }}
        >
          <DeleteIcon id={`${id ?? 'supplierContactCardEditButtonsRow'}DeleteIconBtnDeleteIcon`} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
